import {AbstractReactComponent, i18n, Icon} from 'mc/lib';
import {objectById} from 'mc/lib/utils';
import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {Button, ButtonGroup, Card, Col, FormGroup, Input, Label, Row} from 'reactstrap';
import {CurrentZadostActions} from '../../actions';
import {Api} from '../../api';
import {PrilohaDeclaration} from '../../enums';
import {Loading} from '../common';
import ZadostBackButton from './ZadostBackButton';
import ZadostFooter from './ZadostFooter';
import ZadostLayout from './ZadostLayout';
import './ZadostNalezitosti.scss';
import ZadostNextButton from './ZadostNextButton';
import ZadostSubjekt from './ZadostSubjekt';
import ZadostZadatel from './ZadostZadatel';


class ZadostNalezitosti extends AbstractReactComponent {

    state : {id:number} = {id:parseInt(this.props.params.id)};

    componentDidMount() {
        const id = parseInt(this.props.params.id);
        if (!isNaN(id)) {
            this.setState({id});
        }
        this.dispatch(CurrentZadostActions.fetchIfNeeded(id, true, true, false));
    }

    componentWillUnmount() {
        this.dispatch(CurrentZadostActions.invalidate());
    }

    handleUpload = (e: FileEvent, idTypPriloha: number) => {
        const fileList = e.target.files;
        if (fileList.length !== 1) {
            return;
        }
        const file = fileList[0];

        this.savePriloha(idTypPriloha, PrilohaDeclaration.Digital, file);
        e.target.value = null;
    };

    savePriloha = (idTypPriloha, declaration, data) => {
        Api.savePriloha(this.state.id, idTypPriloha, declaration, data).then(priloha => {
            this.props.dispatch(CurrentZadostActions.setPrilohaState(this.state.id, idTypPriloha, priloha));
        });
    };

    renderPriloha = typPriloha => {
        const {zadost} = this.props;
        const priloha = objectById(zadost.prilohaList, typPriloha.id, 'idTypPriloha');
        const ref = 'uploadInput_' + typPriloha.id;
        const stav = priloha ? priloha.stav : null;
        const stavDecided = PrilohaDeclaration.isDecided(stav);

        return <Row key={"priloha-" + typPriloha.id}>
            <Col xs={12} className="priloha-row">
                <Row>
                    <Col xs={12}>
                        <h4>
                            <Icon className="align-middle" icon={stavDecided ? 'check-square-o' : 'square-o'} fixedWidth/>
                            {' '}
                            <span className="align-middle">{typPriloha.nazev}</span>
                        </h4>
                    </Col>
                </Row>
                {typPriloha.popis && <p dangerouslySetInnerHTML={{__html: typPriloha.popis}}></p>}
                <ButtonGroup>
                    <Button color={stav === PrilohaDeclaration.Digital ? 'success' : 'default'}
                            disabled={stav === PrilohaDeclaration.Digital}
                            onClick={() => { ReactDOM.findDOMNode(this.refs[ref]).click(); }}>
                        {stav === PrilohaDeclaration.Digital && <Icon icon="check"/>}
                        {' ' + i18n('zadostNalezitosti.attacheFile')}
                    </Button>
                    <Input className="d-none" type="file" ref={ref}
                           onChange={(e) => this.handleUpload(e, typPriloha.id)} />
                    <Button color={stav === PrilohaDeclaration.Paper ? "success" : "default"}
                            disabled={stav === PrilohaDeclaration.Paper}
                            onClick={() => {this.savePriloha(typPriloha.id, PrilohaDeclaration.Paper)}}>
                        {stav === PrilohaDeclaration.Paper && <Icon icon="check"/>}
                        {' ' + i18n('zadostNalezitosti.declaration.L')}
                    </Button>
                    {typPriloha.povolitPrilohaStavN && (
                        <Button color={stav === PrilohaDeclaration.NoDeclaration ? "success" : "default"}
                                disabled={stav === PrilohaDeclaration.NoDeclaration}
                                onClick={() => {this.savePriloha(typPriloha.id, PrilohaDeclaration.NoDeclaration)}}>
                            {stav === PrilohaDeclaration.NoDeclaration && <Icon icon="check"/>}
                            {' ' + i18n('zadostNalezitosti.declaration.N')}
                        </Button>
                    )}
                </ButtonGroup>
                {stav === PrilohaDeclaration.Digital && (
                    <div className="actions">
                        <a href={serverContextPath + "/api/zadost/" + this.state.id +"/priloha/" + typPriloha.id} target="_blank">
                            <Icon icon="download"/> {priloha.nazev}
                        </a>
                        <Button color="link" title={i18n('global.delete')}
                                onClick={() => this.savePriloha(typPriloha.id, PrilohaDeclaration.Undecided)}>
                            <Icon icon="times"/>
                        </Button>
                    </div>
                )}
            </Col>
        </Row>
    };

    subjektRow = (roleSubjekt : Object) => {
        return <Row key={"role-"+roleSubjekt.id}>
            <Col xs={12}>
                <FormGroup>
                    <Label>{roleSubjekt.nazev}</Label>
                    <ZadostSubjekt idZadost={this.props.zadost.id} idRoleSubjekt={roleSubjekt.id}/>
                </FormGroup>
            </Col>
        </Row>
    };

    render() {
        const {typZabor, zadost} = this.props;
        if (!typZabor) {
            return <Loading block="full"/>;
        }

        const {roleSubjektList, druhUcelList, typPrilohaList} = typZabor;

        const zadostInfoHint = typZabor.popis + "\n" + druhUcelList.map(i => i.nazev).toString().replace(/,/g, ' | ');
        return <ZadostLayout className="zadost-nalezitosti" stage={2}>
            <Row>
                <Col xs={12}>
                    <h1 style={{marginBottom:'20px'}}>{i18n('zadostNalezitosti.title')}</h1>
                    <Card block>
                        <Row>
                            <Col xs={12} className="col-xl-10">
                                <Row className="section">
                                    <Col xs={12}>
                                        <Row>
                                            <Col xs={12} sm={4} md={2}>Typ žádosti:</Col>
                                            <Col xs={12} sm={8} md={10}><h3 style={{marginTop:0}} className="typ" title={zadostInfoHint}><img src={serverContextPath + "/img/" + typZabor.ikona} /> {typZabor.nazev}</h3></Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} sm={4} md={2}>Referenční číslo:</Col>
                                            <Col xs={12} sm={8} md={10}>
                                                <p>{zadost.refCislo.match(/.{4}/g).join('-')}</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="section subjekty">
                                    <Col xs={12} sm={4} md={2}>{i18n('zadostNalezitosti.requiredInfo')}</Col>
                                    <Col xs={12} sm={8} md={10}>
                                        <Row key="zadatel">
                                            <Col xs={12}>
                                                <FormGroup>
                                                    <Label>{i18n('zadostNalezitosti.applicant')}</Label>
                                                    <ZadostZadatel idZadost={zadost.id}/>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {roleSubjektList.map(this.subjektRow)}
                                    </Col>
                                </Row>
                                <Row className="section">
                                    <Col xs={12} sm={4} md={2}>{i18n('zadostNalezitosti.requiredAttachments')}</Col>
                                    <Col xs={12} sm={8} md={10}>
                                        {typPrilohaList.map(this.renderPriloha)}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                    <ZadostFooter>
                        <ZadostBackButton path={`/zadost/${zadost.id}/typ`}/>
                        <ZadostNextButton path={`/zadost/${zadost.id}/zakres`}/>
                    </ZadostFooter>
                </Col>
            </Row>
        </ZadostLayout>
    }
}

const mapStateToProps = state => {
    const {app:{currentZadost: {data}}} = state;
    return {
        zadost: data,
        typZabor: data ? data.typZabor : null,
        initialValues: {typZabor: data ? data.typZabor.id : null},
    };
};

export default connect(mapStateToProps, null, null, {withRef: true})(ZadostNalezitosti);
